import { createFileRoute } from '@tanstack/react-router'
import EmployeeGiftsPage from '@/features/employee-gifts'

export const Route = createFileRoute('/_authenticated/employee-gifts')({
  component: EmployeeGiftsPage,
}) 